import { render, staticRenderFns } from "./BuyLabelPopup.vue?vue&type=template&id=5b697132&scoped=true"
import script from "./BuyLabelPopup.vue?vue&type=script&lang=js"
export * from "./BuyLabelPopup.vue?vue&type=script&lang=js"
import style0 from "./BuyLabelPopup.vue?vue&type=style&index=0&id=5b697132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b697132",
  null
  
)

export default component.exports